import { a11yProps } from '@/components/Common/CustomTabPanel';
import { Box, Tab, Tabs } from '@mui/material';

import { useState } from 'react';

import UpSellsAndCrossSells from './components/UpSellsAndCrossSells';
import AlternativeNames from './components/AlternativeNames';
import AdditionalSettings from './components/AdditionalSettings';
import { Outlet } from 'react-router-dom';

export default function StreamOrderSettings() {
  const [value, setValue] = useState<number>(0);
  return (
    <>
      <Box bgcolor='background.paper' mt={0} mb={2} py={0.5} sx={{ flexShrink: 0 }}>
        <Tabs
          sx={{ bgcolor: '#F8F9FA' }}
          value={value}
          onChange={(_, newValue) => setValue(newValue)}
          aria-label='configure tabs'
        >
          <Tab sx={{ width: '33.3%' }} label='Upsell & Cross Sell' {...a11yProps('streamOrder', 'settings', 0)} />
          <Tab sx={{ width: '33.3%' }} label='Alternative Names' {...a11yProps('streamOrder', 'settings', 1)} />
          <Tab sx={{ width: '33.3%' }} label='Additional Settings' {...a11yProps('streamOrder', 'settings', 2)} />
        </Tabs>
        <Box my={3} paddingX={1} paddingY={2} border='1px solid #ECECEC' borderRadius='8px'>
          {value === 0 && <UpSellsAndCrossSells />}
          {value === 1 && <AlternativeNames />}
          {value === 2 && <AdditionalSettings />}
        </Box>
        <Outlet />
      </Box>
    </>
  );
}
